import useCheckoutPresenter from '@Screens/Checkout/presenter';
import { ScrollViewMarker } from '@Utils/scroll-view-manager/scroll-view-marker';
import { observer } from 'mobx-react-lite';
import type { ComponentProps } from 'react';

type Props = Omit<ComponentProps<typeof ScrollViewMarker>, 'manager'>;

export const ProductPanelScrollMarker = observer(
  function ProductPanelScrollMarker(props: Props) {
    const { scrollViewManager } = useCheckoutPresenter();
    return <ScrollViewMarker {...props} manager={scrollViewManager} />;
  }
);
